import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { isEmpty, isEqual, get } from 'lodash';
import { Link } from 'react-router-dom';

import { Container, Title, Form, Wrapper } from 'components/Ui';
import Loader from 'components/Loader';
import ContentfulFields from 'components/ContentfulFields';
import CartInfo from 'containers/Cart/CartInfo';

import { CART_PAGE_KEY } from '../constants';
import styles from './styles.scss';

class Cart extends PureComponent {
  componentDidMount() {
    const {
      cart: { items: cartItems },
    } = this.props;
    this.props.fetchPage({ key: CART_PAGE_KEY });

    if (!isEmpty(cartItems)) {
      this.props.loadCartProducts(cartItems);
    }
  }

  componentDidUpdate(prevProps) {
    const {
      cart: { items: prevCartItems },
    } = prevProps;
    const {
      cart: { items: cartItems },
    } = this.props;

    if (!isEmpty(cartItems) && !isEqual(prevCartItems, cartItems)) {
      this.props.loadCartProducts(cartItems);
    }
  }

  render() {
    const {
      site: {
        components: { page },
        loading: siteLoading,
      },
      cart,
      cartLoading,
      authenticationLoading,
    } = this.props;

    return (
      <Loader loading={siteLoading || cartLoading || authenticationLoading}>
        <Container value="Cart" className={styles.container}>
          {page &&
            page.contentModules.map((banner) => (
              <div key={banner.sys.id} className={styles.cartBanner}>
                <ContentfulFields
                  type={get(banner, 'sys.contentType.sys.id')}
                  document={banner}
                />
              </div>
            ))}
          <Title large>Shopping Cart</Title>
          {!cart || isEmpty(cart.items) ? (
            <Wrapper color="grey" className={styles.emptyCart}>
              <div className={styles.emptyTitle}>
                Cart is empty
                <br />
              </div>
              <div>
                Visit <Link to="/products">Our Products</Link> page
              </div>
            </Wrapper>
          ) : (
            <Form className={styles.cart} color="grey">
              <CartInfo cart={cart} page="cart" />
            </Form>
          )}
        </Container>
      </Loader>
    );
  }
}

Cart.propTypes = {
  site: PropTypes.object.isRequired,
  cart: PropTypes.object.isRequired,
  cartLoading: PropTypes.bool.isRequired,
  authenticationLoading: PropTypes.bool.isRequired,
  fetchPage: PropTypes.func.isRequired,
  loadCartProducts: PropTypes.func.isRequired,
};

export default Cart;
